var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c("emc-table-icon", {
        attrs: {
          disabled: _vm.disabled || !_vm.gridId,
          loading: _vm.loading,
          icon: "mdi-calendar-month-outline",
          color: _vm.color,
          "tool-tip": _vm.toolTip,
        },
        on: { click: _vm.open },
      }),
      _c("emc-modal-form", {
        attrs: {
          title: _vm.maskName || "Datas da grade",
          "title-tool-tip": _vm.maskName,
          icon: "mdi-calendar-month-outline",
          maxWidth: "600",
          show: _vm.dialog,
        },
        on: {
          "update:show": function ($event) {
            _vm.dialog = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "form",
            fn: function () {
              return [
                _vm.loading
                  ? _c(
                      "div",
                      { staticClass: "text-center py-6" },
                      [
                        _c("v-progress-circular", {
                          attrs: { indeterminate: "", color: "primary" },
                        }),
                      ],
                      1
                    )
                  : _vm.errorMessage
                  ? _c(
                      "v-alert",
                      { attrs: { type: "error", dense: "", text: "" } },
                      [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
                    )
                  : [
                      _c("v-simple-table", {
                        attrs: { dense: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function () {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("Data")]),
                                    _c("th", [_vm._v("Início")]),
                                    _c("th", [_vm._v("Fim")]),
                                  ]),
                                ]),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(
                                      _vm.groupedDates,
                                      function (item, index) {
                                        return _c("tr", { key: index }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(_vm._f("date")(item.date))
                                            ),
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(item.hour_start)),
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(item.hour_end)),
                                          ]),
                                        ])
                                      }
                                    ),
                                    _vm.dates.length === 0
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-center text--secondary",
                                              attrs: { colspan: "3" },
                                            },
                                            [
                                              _vm._v(
                                                " Nenhuma data encontrada para esta grade. "
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }